import { Menu, MenuItem, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  anchorEl: any | null;
  menuOpen: boolean;

  handleAdminLogin(): void;

  handleOpenEditUserDialog(): void;

  handleOpenDeleteUserDialog(): void;

  handleCloseMenu(): void;
}

const UserItemMenu: React.FC<Props> = ({
  anchorEl,
  menuOpen,
  handleAdminLogin,
  handleOpenEditUserDialog,
  handleOpenDeleteUserDialog,
  handleCloseMenu,
}) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Menu
      classes={{ list: classes.menuList, paper: classes.menuPaper }}
      anchorEl={anchorEl}
      open={menuOpen}
      onClose={handleCloseMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{ paper: { style: { width: 'auto' } } }}
      disableEnforceFocus={true}
      disableAutoFocus={true}
      disableAutoFocusItem={true}
      disableRestoreFocus={true}
    >
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleAdminLogin();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('adminLogin')}</Typography>
      </MenuItem>
      <MenuItem
        className={classes.menuItem}
        disableRipple={true}
        onClick={() => {
          handleOpenEditUserDialog();
          handleCloseMenu();
        }}
      >
        <Typography className={classes.menuItemText}>{t('editUser')}</Typography>
      </MenuItem>
      {!_.isNil(handleOpenDeleteUserDialog) ? (
        <MenuItem
          className={classes.menuItem}
          disableRipple={true}
          onClick={() => {
            handleOpenDeleteUserDialog();
            handleCloseMenu();
          }}
        >
          <Typography className={cx(classes.menuItemText, 'delete')}>{t('deleteUser')}</Typography>
        </MenuItem>
      ) : null}
    </Menu>
  );
};

const useStyles = makeStyles()((theme) => ({
  menuPaper: {
    borderRadius: '8px',
    maxHeight: '33vh',
    width: '100%',
    marginLeft: '8px',
  },
  menuList: {
    padding: 0,
  },
  menuItem: {
    fontSize: theme.typography.pxToRem(15),
    borderBottom: `1px solid ${theme.palette.greys.lighter}`,
    padding: '6px 16px',
    '&:last-of-type': {
      borderBottom: 'unset',
    },
    '&.Mui-selected': {
      background: theme.palette.backgrounds.main,

      '&:hover, &:focus': {
        background: theme.palette.backgrounds.main,
      },
    },
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&:focus': {
      background: theme.palette.action.hover,
    },
  },
  menuItemText: {
    fontSize: theme.typography.pxToRem(13),
    '&.delete': {
      color: theme.palette.error.main,
    },
  },
}));

export default UserItemMenu;
